import { createApi } from '@reduxjs/toolkit/query/react'
import Strapi, { EndpointQueryParameters, StrapiSingle, StrapiUpdate } from '../../types/strapi/strapi'
import Machine from '../../types/api/machine'
import getQuery from '../../helpers/api/get-query'
import getCustomFetchBase from '../custom-fetch-base'

export const machinesApi = createApi({
    reducerPath: 'machinesApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Machines', 'PrintJobs'],
    endpoints: builder => ({
        getMachines: builder.query<Strapi<Machine>, EndpointQueryParameters | void>({
            query: getQuery('/machines'),
            providesTags: ['Machines'],
        }),
        updateMachine: builder.mutation<StrapiSingle<Machine>, StrapiUpdate<Machine>>({
            query: ({ docId, body }) => ({
                url: `/machines/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Machines', 'PrintJobs'],
        }),
    }),
})

export const { useGetMachinesQuery, useUpdateMachineMutation } = machinesApi
